import React from 'react';
import { Link } from 'react-router-dom';
import AlertBar from '../../components/alertBar';
import Header from '../../components/header';
import BigImageSlider from '../../components/bigImageSlider';
import Footer from '../../components/footer';
import languageService from '../../services/language';
import './index.css';

export default (props, routerProps) => ({
  render() {
    return (
      <div className="viewsBy">
        <h6>Site realizat de Spinaltec</h6>
        <h6>Ștefan Moraru - <a href="http://www.stefanmoraru.ro" target="_blank">www.stefanmoraru.ro</a> - Infrastructură, Programare, Design</h6>
        <h6>Emilian Damian - Infrastructură, Programare</h6>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/views/by/index.js